import { privateAxios, publicAxios } from "@src/axios.config"

export const blacklistRefreshToken = async () => {
    const refresh = localStorage.getItem("RefreshToken");
    if (!refresh) return;
    try {
        await publicAxios.post("/api/auth/blacklist", { refresh_token: refresh });
    } catch (_) {}
};

export const handleTokenRefresh = async () => {
    return await privateAxios.post("/api/auth/refresh", {
        refresh: localStorage.getItem("RefreshToken"),
    })
}

export const updatePassword = async (old_password = "", new_password = "") => {
    return await privateAxios.post("/api/users/change-password", { old_password, new_password }) //need to fix
}

export const checkEmailAddress = async (email = "", username = "") => {
    return await publicAxios.post(`/api/auth/pre-create`, { username, email })
}

export const handleSignup = async (data) => {
    return await publicAxios.post(`/api/auth/signup`, data)
}

export const getSecurityQuestions = async () => {
    return await publicAxios.get("/api/auth/security-questions")
}

/** Returns { questions_configured, mfa_configured } for the current user (authenticated). */
export const getSecuritySetupStatus = async () => {
    return await privateAxios.get("/api/auth/security-setup-status")
}

export const setupSecurityQuestions = async (setupToken, questions) => {
    const body = { questions }
    if (setupToken) body.setup_token = setupToken
    const client = setupToken ? publicAxios : privateAxios
    return await client.post("/api/auth/setup-security-questions", body)
}

export const setupTotp = async (setupToken) => {
    const body = setupToken ? { setup_token: setupToken } : {}
    const client = setupToken ? publicAxios : privateAxios
    return await client.post("/api/auth/setup-totp", body)
}

export const verifyTotp = async (setupToken, code) => {
    const body = { code }
    if (setupToken) body.setup_token = setupToken
    const client = setupToken ? publicAxios : privateAxios
    return await client.post("/api/auth/verify-totp", body)
}

export const continueLater = async (setupToken) => {
    return await publicAxios.post("/api/auth/continue-later", {
        setup_token: setupToken,
    })
}

export const resumeSignup = async (continueToken) => {
    return await publicAxios.get(`/api/auth/resume-signup/${continueToken}`)
}

export const checkReturningUser = async (email) => {
    return await publicAxios.post("/api/auth/check-returning-user", {
        email,
    })
}

export const restartSignup = async (email) => {
    return await publicAxios.post("/api/auth/restart-signup", {
        email,
    })
}

export const resendVerificationEmail = async (email, password) => {
    return await publicAxios.post("/api/auth/resend-verification-email", {
        email,
        password,
    })
}

export const handleLogin = async (data) => {
    return await publicAxios.post(`/api/auth/`, data)
}

export const loginStep1 = async (email, password, deviceToken = null) => {
    const body = { email, password }
    if (deviceToken) body.device_token = deviceToken
    return await publicAxios.post("/api/auth/login/step1", body)
}

export const loginStep2 = async (progressToken, questionId, answer, rememberDevice) => {
    return await publicAxios.post("/api/auth/login/step2", {
        progress_token: progressToken,
        question_id: questionId,
        answer,
        remember_device: rememberDevice,
    })
}

export const loginStep3 = async (progressToken, code) => {
    return await publicAxios.post("/api/auth/login/step3", {
        progress_token: progressToken,
        code,
    })
}

export const loginStep4 = async (progressToken, recaptchaToken) => {
    return await publicAxios.post("/api/auth/login/step4", {
        progress_token: progressToken,
        recaptcha_token: recaptchaToken || undefined,
    })
}

export const requestResetPassword = async (data) => {
    return await publicAxios.post(`/api/auth/request-reset-password`, data)
}

export const resetPassword = async (data) => {
    return await publicAxios.post(`/api/auth/reset-password`, data)
}

export const fetchForgotPasswordQuestions = async (email) => {
    return await publicAxios.post("/api/auth/forgot-password-questions", { email })
}

/** Forgot password: email + 3 security answers + TOTP. Returns uid + link_token (+ temp_password for API clients); UI uses temp password from email only. */
export const forgotPasswordWithQuestions = async (email, questions, totpCode) => {
    return await publicAxios.post("/api/auth/forgot-password", {
        email,
        questions,
        totp_code: totpCode,
    })
}

/** Forgot by identifier (don't remember security answers): identifier + TOTP. Same response. */
export const forgotPasswordByIdentifier = async (identifier, totpCode) => {
    return await publicAxios.post("/api/auth/forgot-password-by-identifier", {
        identifier,
        totp_code: totpCode,
    })
}

/** Set new password from reset link: TOTP + temp password + new password + confirm (before login). */
export const resetPasswordWithTemp = async (uid, token, totpCode, tempPassword, newPassword, confirmPassword) => {
    return await publicAxios.post("/api/auth/reset-password-with-temp", {
        uid,
        token,
        totp_code: totpCode,
        temp_password: tempPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
    })
}

/** Change password (logged in): old + new + confirm + optional recaptcha_token. */
export const changePassword = async (oldPassword, newPassword, confirmPassword, recaptchaToken = null) => {
    const body = { old_password: oldPassword, new_password: newPassword, confirm_password: confirmPassword }
    if (recaptchaToken) body.recaptcha_token = recaptchaToken
    return await privateAxios.post("/api/users/change-password", body)
}
